
import {Vue, Component, Prop} from "vue-property-decorator";
import getUnicodeFlagIcon from "country-flag-icons/unicode";
import { Getter } from "vuex-class";

@Component({})
export default class LocaleSwitcher extends Vue {
    @Getter private isMobile: boolean;

    get locales(): string[] {
        // Return all available locales (detected by i18n with locales files found in the locale folder)
        return this.$root.$i18n.availableLocales;
    }

    private getIconByLocale(locale: string): any {
        if (locale === "en") {
            return getUnicodeFlagIcon("GB");
        }
        return getUnicodeFlagIcon(locale.toUpperCase());
    }
}
